import { render, staticRenderFns } from "./NotificationsTemplate.vue?vue&type=template&id=40ec25d6&"
import script from "./NotificationsTemplate.vue?vue&type=script&lang=js&"
export * from "./NotificationsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports